// extracted by mini-css-extract-plugin
export default {"deleteButton":"form-list_deleteButton__AhTEz","icon":"form-list_icon__H8hC9"};